<template>
    <div v-if="product_data">
        <div v-if="edit === false">
            <b-card :title="product_data.product_name" sub-title=" " v-if="product_data.properties">
                <b-card-text>
                    <b>SKU:</b> {{ product_data.sku }}
                </b-card-text>

                <b-card-text>
                    <b>Vendor:</b> {{ product_data.vendor }}
                </b-card-text>

                <!-- <b-card-text>
                    <b>Brand:</b> {{ product_data.brand }}
                </b-card-text> -->

                <b-card-text>
                    <b>Category:</b> {{ product_data.category }}
                </b-card-text>

                <b-card-text>
                    <b>Time added:</b> {{ product_data.ts || new Date() }}
                </b-card-text>

                <b-card-text>
                    <b>Selling Price:</b> ${{ product_data.selling_price * 1.0 }}
                </b-card-text>

                <b-card-text>
                    <b>Wholesale Price:</b> ${{ product_data.properties.wholesale_price }}
                </b-card-text>

                <b-card-text v-if="'items' in product_data">
                    <span v-for="item in Object.keys(product_data.items)">
                        <span v-if="product_data.items[item] > 0">
                            <b-button  variant="success" style="margin: 2px;" size="sm">
                                {{ item }} 
                                <b-badge variant="light"> {{ product_data.items[item] }}</b-badge>
                            </b-button>
                        </span>

                        <span v-else>
                            <b-button  variant="secondary" style="margin: 2px;" size="sm">
                                {{ item }} 
                                <b-badge variant="light"> {{ product_data.items[item] }}</b-badge>
                            </b-button>
                        </span>
                    </span>
                </b-card-text>

                <b-card-text>
                    <b>Active Status:</b> 
                    {{ product_data.properties.status }}
                </b-card-text>

                <div v-if="product_data.properties.image_urls">
                    <lingallery :width="600" :height="400" :items="product_data.properties.image_urls" />
                </div>
                <button v-on:click="triggerEdit">Edit</button>
            </b-card>

        </div>
        <div v-else>
            
            <b-card :title="product_data.product_name" sub-title=" ">
                <div>
                    <span style="display: inline-block; margin: 10px; width: 400px;">
                        <b-card-text>
                            <b>Product Name:</b> <b-input required v-model="product_data.product_name" :value="product_data.product_name"></b-input>
                        </b-card-text>
                    </span>

                    <span style="display: inline-block; margin: 10px; width: 400px;">
                        <b-card-text>
                            <b>SKU:</b> <b-input required v-model="product_data.sku" :value="product_data.sku"></b-input>
                        </b-card-text>
                    </span>
                </div>

                <div>
                    <span style="display: inline-block; margin: 10px; width: 200px;">
                        <b-card-text>
                            <b>Vendor:</b>
                            <b-form-select
                                v-model="product_data.vendor_id"
                                :options="dropdown_params.vendors"
                                
                            ></b-form-select>
                        </b-card-text>
                    </span>

                    <span style="display: inline-block; margin: 10px; width: 200px;">
                        <b-card-text>
                            <b>Category:</b>
                            <b-form-select
                                v-model="product_data.category_id"
                                :options="dropdown_params.categories"
                                
                            ></b-form-select>
                        </b-card-text>
                    </span>
                    
                    <span style="display: inline-block; margin: 10px; width: 100px;">
                        <b-card-text>
                            <b>S Price:</b>
                            <b-input v-model="product_data.selling_price" :value="product_data.selling_price" type="number"></b-input>
                        </b-card-text>
                    </span>

                    <span style="display: inline-block; margin: 10px; width: 100px;">
                        <b-card-text>
                            <b>WS Price:</b>
                            <b-input v-model="product_data.properties.wholesale_price" :value="product_data.properties.wholesale_price" type="number"></b-input>
                        </b-card-text>
                    </span>

                    <span style="display: inline-block; margin: 10px;">
                        <b-card-text>
                            <b>Active Status:</b>
                            <b-form-select
                                v-model="product_data.properties.status"
                                :options="dropdown_params.statuses"
                            ></b-form-select>
                        </b-card-text>
                    </span>
                </div>

            </b-card>

            <b-card>
                <b>Children</b>
                <div>
                    <!--THIS IS FOR SHOWING EXISTING CHILDREN IF ANY-->
                    <b-alert show variant="secondary">
                        <vue-good-table
                            :columns="children_columns"
                            @on-cell-click="onColumnClickChildrenSearch"
                            :rows="product_data.children"
                            :pagination-options="{
                                enabled: false,
                                mode: 'pages',
                                position: 'top',
                                perPage: 10
                            }"
                            :select-options="{ enabled: false }"
                            styleClass="vgt-table bordered condensed"
                        > 
                            
                        <template slot="table-row" slot-scope="props">
                            <span v-show="(edit === true)" v-if="props.column.field == 'actions'">
                                <b-button variant="outline-danger" size="sm"><b>Remove</b></b-button>
                                <!--b-button variant="outline-primary" size="sm"><b>Reserve</b></b-button-->
                            </span>

                             <!-- <span v-show="(edit === true)" v-if="props.column.field == 'quantity'">
                               <b-input type="number" v-model="props.row.quantity" style="width: 200px; margin: auto;"></b-input>
                            </span> -->

                            <span v-else>
                                {{props.formattedRow[props.column.field]}}
                            </span>
                        </template>
                        </vue-good-table>
                    </b-alert>
                </div>
            </b-card>
            <b-card>
                <div>
                    <b-button v-b-toggle.add-new-children variant="secondary" size="sm">
                        Add new children
                    </b-button>

                    <!--THIS IS FOR SHOWING CHILDREN SEARCH RESULTS TO ADD -->

                    <b-collapse id="add-new-children">
                        <b-alert show variant="warning">
                            <b-input type="text" placeholder="enter sku or name" style="width: 300px; display: inline-block;" v-model="children_search.keyword"></b-input>
                            <b-button size="sm" variant="primary" @click="childrenSearch">Search</b-button>
                            <vue-good-table
                              :columns="children_search.children_search_columns"
                              @on-cell-click="onColumnClickChildrenSearch"
                              :rows="children_search.children_search_results"
                              :pagination-options="{
                                enabled: true,
                                mode: 'pages',
                                position: 'top',
                                perPage: 10
                              }"
                              :select-options="{ enabled: false }"
                              styleClass="vgt-table bordered condensed"
                              style="font-size: 10px;"
                            > 
                            
                                <template slot="table-row" slot-scope="props">
                                    <span v-show="(edit === true)" v-if="props.column.field == 'actions'">
                                        <b-button variant="outline-success" size="sm"><b>Add as child</b></b-button>
                                        <!--b-button variant="outline-primary" size="sm"><b>Reserve</b></b-button-->
                                    </span>

                                     <span v-show="(edit === true)" v-if="props.column.field == 'quantity'">
                                       <b-input type="number" v-model="new_children_quantity[props.row.id]" style="width: 50px; margin: auto;"></b-input>
                                    </span>

                                    <span v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>
                            </vue-good-table>
                        </b-alert>
                    </b-collapse>
                </div>

                <!--b-card-text>
                    <b>Add Images:</b>

                    <vue-upload-multiple-image
                        @upload-success="uploadImageSuccess"
                        @before-remove="beforeRemove"
                        @edit-image="editImage"
                        :data-images="images"
                        dragText="Upload Images"
                        browseText="Max Size (<= 2mb)"
                        primaryText=""
                        popupText=""
                        markIsPrimaryText=""
                    ></vue-upload-multiple-image>
                </b-card-text-->
            </b-card>

            <b-card>
                <div v-if="product_data.id">
                    <button v-on:click="cancelEdit">Cancel</button>
                    <button v-on:click="updateEdit">Update</button>
                </div>
                <div v-else>
                    <button v-on:click="addNew">Submit</button>
                    <button v-on:click="cancelAdd">Cancel</button>
                </div>
            </b-card>
        </div>

    </div>
</template>

<script>
    import VueUploadMultipleImage from 'vue-upload-multiple-image'
    import Requestor from '@/utilities/Requestor'
    import Lingallery from 'lingallery';

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    export default {
        name: "Product",
        components: {VueGoodTable, VueUploadMultipleImage, Lingallery},
        props: ["viewdata", "new"],
        data: function(){
            return {
                edit: false,
                product_data: {properties: {}},
                images: [],
                added_images: [],
                dropdown_params: {
                    vendors: [],
                    categories: [],
                    statuses: [],
                    brands: [],
                },
                children_columns: [
                    {
                        label: "ID",
                        field: "id",
                        filterable: true,
                        type: "number",
                        sortable: true,
                    },
                    {
                        label: "Product",
                        field: "product_name",
                        filterable: true,
                        sortable: true,
                    },
                    {
                        label: "SKU",
                        field: "sku",
                        filterable: true,
                        sortable: true,
                    },
                    {
                        label: "Vendor",
                        field: "vendor",
                        filterable: true,
                        sortable: true,
                    },
                    {
                        label: "Quantity",
                        field: "quantity",
                        filterable: false,
                        sortable: false,
                        type: "number",
                        
                    },
                    {
                        label: "Action",
                        field: "actions",
                        filterable: false,
                        type: "html",
                        sortable: false,
                    },
                ],
                new_children_quantity: {},
                children_search: {
                    keyword: null,
                    children_search_results: [],
                    children_search_columns: [
                        {
                            label: "ID",
                            field: "id",
                            filterable: true,
                            type: "number",
                            sortable: true,
                        },
                        {
                            label: "Product",
                            field: "product_name",
                            filterable: true,
                            sortable: true,
                        },
                        {
                            label: "SKU",
                            field: "sku",
                            filterable: true,
                            sortable: true,
                        },
                        {
                            label: "Vendor",
                            field: "vendor",
                            filterable: true,
                            sortable: true,
                        },
                        {
                            label: "Quantity",
                            field: "quantity",
                            filterable: false,
                            sortable: false,
                            type: "html"
                        },
                        {
                            label: "Action",
                            field: "actions",
                            filterable: false,
                            type: "html",
                            sortable: false,
                        },
                    ],
                },
            }
        },
        methods: {
            childrenSearch: function(e){
                if (e){
                    e.preventDefault();
                }

                let keyword = this.children_search.keyword;

                if (!(keyword) || (keyword.length < 2)){
                    this.$bvToast.toast(
                        "Invalid keyword.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }
                let that = this;
                let path = "/api/product/search_product/";
                let data = {
                    "lookup_type": "product_and_sku", 
                    "search_value": keyword,
                    "only_child": true 
                }
                let s = function(response){
                    if (response.data.result){

                        that.children_search.children_search_results = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            "No results found", 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }
                let f = function(error){
                    console.log(error);
                }
                Requestor.getSyncP(path, data, this, s, f);


            },
            onColumnClickChildren: function(params){
                console.log(params);
            },
            onColumnClickChildrenSearch: function(params){

                if (params.column.field != "actions"){
                    return
                }

                let row_data = params;
                let action = params.event.target.innerText;
                
                if (action === "Add as child") {
                    let new_child = {
                        id: row_data.row.id,
                        product_name: row_data.row.product_name,
                        sku: row_data.row.sku,
                        vendor: row_data.row.vendor,
                        quantity: parseInt(this.new_children_quantity[row_data.row.id]),
                    }


                    if (new_child.quantity <= 0 || isNaN(new_child.quantity) || new_child.quantity == null){
                        this.$bvToast.toast(
                            "Enter a real number for the child quantity.", 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        return
                    }
                    this.product_data.children.push(new_child);
                }
                
            },

            mapKey: function(value, fromMap){
                let mapping = [];
                let out;
                if (fromMap === "vendors"){
                    mapping = this.dropdown_params.vendors;
                }
                else if (fromMap == "categories"){
                    mapping = this.dropdown_params.categories;
                }
                if (mapping){
                    let result = mapping.filter(function(x){return x.value == value});
                
                    if (result.length > 0){
                        out = result[0].text;
                    }
                }
                return out;
            },
            uploadImageSuccess(formData, index, fileList){
                this.added_images = fileList;
                //console.log(this.added_images);
                // Upload image api
                // axios.post('http://your-url-upload', formData).then(response => {
                //   console.log(response)
                // })
            },
            beforeRemove (index, done, fileList){
                var r = confirm("remove image")
                if (r == true) {
                    done()
                    this.added_images = fileList;
                } else {
                    return
                }
            },
            editImage (formData, index, fileList){
                console.log("edit data", formData, index, fileList)
            },
            cancelAdd: function(e){
                e.preventDefault();
                //this.product_data = this.viewdata;
                this.product_data = {properties: {}};
                
                this.$bvModal.hide("modal-new-product");
                this.$bvModal.hide("modal-product");

            },
            cancelEdit: function(e){
                e.preventDefault();
                //this.product_data = this.viewdata;
                this.product_data = JSON.parse(JSON.stringify(this.viewdata));
                this.edit = false;
            },
            updateEdit: function(e){
                e.preventDefault();
                let that = this;

                let path = "/api/product/update_product/";
                //let data = {"product": this.viewdata, "images": this.added_images, "others": {}}
                let errors = this.validateInput();
                if (errors.length > 0){
                    this.$bvToast.toast(
                        errors[0], 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }
                let data = {product: this.product_data, images: {}, others: {}};
                let s = function(response){
                    if (response.data){
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error, 
                                {title: "Error", autoHideDelay: 1500, variant:"danger"}
                            );
                            that.product_data = JSON.parse(JSON.stringify(that.viewdata));
                        }
                        else {
                            that.$bvToast.toast(
                                "Product Data Updated", 
                                {title: "success", autoHideDelay: 1500, variant:"success"}
                            );
                            that.product_data = response.data.result;
                        }
                    }
                    that.edit = false;
                }
                let f = function(error){
                    if (error){
                        that.$bvToast.toast(
                            "Error updating product data. Please try again.", 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    that.product_data = JSON.parse(JSON.stringify(that.viewdata));
                    that.edit = false;
                }
                Requestor.postSyncP(path, data, this, s, f);
            },
            triggerEdit: function(e){
                if (e){
                    e.preventDefault();
                }
                console.log(this.product_data);
                let that = this;

                //if drop down data already exists, why pull it on multiple edits?
                if (this.dropdown_params.vendors.length > 0){
                    this.edit = true;
                    return
                }

                let path = "/api/product/get_edit_dropdown_stuff/";
                let data = {};
                let s = function(response){
                    if (response.data){
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error, 
                                {title: "Error", autoHideDelay: 1500, variant:"danger"}
                            );
                            that.edit = false;
                            return
                        }
                        else {
                            that.dropdown_params = response.data.result;
                            that.edit = true;
                        }
                    }
                }
                let f = function(error){
                    if (error){
                        that.$bvToast.toast(
                            "Edit action cannot be completed.", 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    that.edit = false;
                    return
                }
                Requestor.getSyncP(path, data, this, s, f);
            },
            addNew: function(e){
                if (e){
                    e.preventDefault();
                }

                let that = this;
                let path = "/api/product/add_product/";
                let errors = this.validateInput();
                if (errors.length > 0){
                    this.$bvToast.toast(
                        errors[0], 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }

                let data = {product: this.product_data, images: {}, others: {}}
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        //that.edit = false;
                    }
                    else {
                        that.$bvToast.toast(
                            "New Product Added", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.product_data = response.data.result;

                        //dirty engineering here (get rid of this nonsense)
                        that.product_data.category = that.dropdown_params.categories.filter(function(x){return x.value == that.product_data.category_id})[0].text;

                        that.product_data.vendor = that.dropdown_params.vendors.filter(function(x){return x.value == that.product_data.vendor_id})[0].text;


                        that.edit = false;
                    }
                    return
                }

                let f = function(error){
                    that.$bvToast.toast(
                        "Error adding new product", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }

                Requestor.postSyncP(path, data, this, s, f);
            },
            validateInput: function(e){
                if (e){
                    e.preventDefault();
                }

                let errors = [];
                if (!this.product_data.product_name){
                    errors.push("No product name mentioned.");
                }

                if (!this.product_data.sku){
                    errors.push("No product sku added.");
                }
                if (!this.product_data.category_id){
                    errors.push("No product category mentioned.");
                }
                if (!this.product_data.vendor_id){
                    errors.push("No product vendor mentioned.");
                }
                if (!this.product_data.selling_price){
                    errors.push("No selling price mentioned.");
                }

                if (this.product_data.children.length > 0){
                    for (var i = 0; i<this.product_data.children.length; i++){
                        if (this.product_data.children[i].quantity <= 0){
                            errors.push("Cannot have a child product with count <= 0.");
                        }
                    }
                }
                
                return errors
            }

        },
        created: function(){
            //deepcopy
            this.product_data = JSON.parse(JSON.stringify(this.viewdata));
            if (this.product_data.children == null){
                this.product_data.children = [];
            }
            this.new = JSON.parse(JSON.stringify(this.new));
            if (this.new) {
                this.triggerEdit();
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/importables/Product.vue